// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"SubDomainsPage-primaryButton-OwZxvf","container":"SubDomainsPage-container-3TF6aM","pageContainer":"SubDomainsPage-pageContainer-16D6Up"};